import { GetAppBg, GetAppQR, iPhone15Pro } from 'assets';
import AppStoreGetIcon from 'assets/Icons/AppStoreGetIcon';
import PlayStoreGetIcon from 'assets/Icons/PlayStoreGetIcon';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

const GetApp = () => {
  const router = useRouter();
  return (
    <div
      onClick={() => router.push('/get-our-app')}
      className='relative pl-0 md:pl-5 lg:pl-6 xl:pl-12 flex justify-center overflow-hidden'
    >
      <div className='w-full absolute top-0 left-0 h-full bg-[linear-gradient(to_top,#ff561294_0%,transparent_40%)] z-[2]' />
      <div className='w-full absolute top-0 left-0 h-full z-[1] overflow-hidden flex justify-end'>
        <Image
          className='md:w-1/2 w-full md:object-contain object-cover h-auto'
          width={1000}
          height={1000}
          alt='Download zebralearn app QR'
          src={GetAppBg}
        />
      </div>
      <div className='flex max-w-7xl w-full z-[3] flex-col  md:flex-row items-center justify-between gap-6 py-6 md:py-8'>
        <div className='z-[1] flex justify-center items-start flex-col md:px-0 px-4 max-w-xl'>
          <p className='xl:text-4xl md:text-3xl text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-t from-primary to-[#FC7538] xl:mb-3.5 md:mb-3 mb-2.5 leading-tight'>
            Explore ZebraLearn Audiobook exclusively on the app.
          </p>
          <p className='xl:text-lg md:text-sm text-sm text-white font-medium xl:mb-5 md:mb-4 mb-2.5'>
            Start learning anytime, anywhere with the ZebraLearn mobile app.
          </p>
          <ButtonDefault
            className='xl:text-sm md:text-xs text-xs text-white uppercase font-semibold xl:py-2.5 md:py-2 py-1.5 xl:px-4 md:px-2 px-2.5 rounded-lg mb-5'
            size={0}
            variant={ButtonVariants.PRIMARY}
            is3D
          >
            DOWNLOAD THE APP NOW!
          </ButtonDefault>
          <div className='flex xl:gap-5 md:gap-4 gap-5 items-center'>
            <Image
              className='xl:w-[115px] md:w-[100px] w-[115px] xl:h-[115px] md:h-[100px] h-[115px]'
              width={115}
              height={115}
              alt='Download zebralearn app QR'
              src={GetAppQR}
            />
            <div className='flex flex-col justify-center xl:gap-5 md:gap-4 gap-5'>
              <PlayStoreGetIcon
                onClick={(e) => {
                  e.stopPropagation();
                  if (typeof window !== undefined) {
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.zebralearn.reader&utm_source=zebralearn_website' as string,
                      '_blank',
                    );
                  }
                }}
              />
              <AppStoreGetIcon
                onClick={(e) => {
                  e.stopPropagation();
                  if (typeof window !== undefined) {
                    window.open(
                      'https://apps.apple.com/in/app/zebralearn/id6477746268?utm_source=zebralearn_website',
                      '_blank',
                    );
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className='flex items-center justify-center md:justify-end flex-1 w-full max-w-[500px]'>
          <Image
            className='w-full max-w-[460px] h-auto object-contain relative md:left-[-100px] lg:left-[-200px] xl:left-[-230px]'
            width={503}
            height={394}
            alt='Explore ZebraLearn Audiobook exclusively on the app'
            src={iPhone15Pro}
            priority
          />
        </div>
      </div>
    </div>
  );
};

export default GetApp;
